import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { GalleryFactory } from '../../factories/GalleryFactory'
import { EditorComponentContract } from '../EditorComponentContract'

export class Gallery extends EditorComponentContract {
	constructor() {
		super(Variations)
		this.htmlBuilder = HtmlBuilder
		this.factory = new GalleryFactory
	}

	elementIds() {
		return ['id', 'containerId']
	}

	elementClasses() {
		return ['classes', 'containerClasses', 'contentClasses', 'itemClasses']
	}

	elementContents() {
		return ['type', 'images', 'numberImages']
	}

	elementStyles() {
		return [
			{ id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null },
			{ id: 'containerId', element: 'id', styles: 'containerStyles', selector: '#', variation: null },
		]
	}

	info() {
		return {
			name: 'Gallery',
			icon: 'fa-images',
			variations: this.variationsInfo()
		}
	}
}
